import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import i18n from '@src/languages';
import { calculateElapsedDateTime } from '@src/utils/date';
import pluralize from '@src/utils/pluralize';
import CopyableButton from '@src/components/CopyableButton';
import { convertSecondsToHMS } from '@src/utils/time';
import { StyledTableTitle } from './index.style';

const TitleRequest = ({
  requestId,
  audioType,
  characters,
  createdAt,
  credits,
  audioDurationSeconds,
  isSTT,
}) => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const { language } = i18n;

  const ttsMetadata = [
    calculateElapsedDateTime(createdAt, t),
    `${characters?.toLocaleString(language) || 0} ${pluralize(
      characters,
      t('char'),
      language,
    )}`,
    `${credits?.toLocaleString(language) || 0} ${pluralize(
      credits,
      t('credit'),
      language,
    )}`,
    audioType,
  ];

  const sttMetadata = [
    calculateElapsedDateTime(createdAt, t),
    convertSecondsToHMS(audioDurationSeconds),
    `${credits?.toLocaleString(language) || 0} ${pluralize(
      credits,
      t('credit'),
      language,
    )}`,
  ];

  const metadata = isSTT ? sttMetadata : ttsMetadata;

  return (
    <StyledTableTitle ref={ref}>
      <div className="display-title">
        <div className="title">
          <div className="title-text">
            <Typography className="text">{requestId}</Typography>
          </div>
          <CopyableButton color="#1E164ECC" content={requestId} />
        </div>

        <div className="desc-requests">
          {metadata.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <React.Fragment key={`${requestId}-${index}`}>
              {index > 0 && <div className="title-desc">•</div>}
              <div className="title-desc">{item}</div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </StyledTableTitle>
  );
};

export default TitleRequest;
